import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./Convertitore_fatture_PDF_XML/App.tsx";
import LoginPage from "./LoginPage.tsx";
import PrivateRoute from "./PrivateRoute.tsx";
import ProfiloUtente from "./ProfiloUtente.tsx";
import "./styles.css"; 
import Goodbye from "./GoodByePage.tsx";
import { ConfirmToastProvider } from './alertFunction.tsx';
import {AuthProvider} from "./AuthProvider.tsx"; 
import { FileProvider } from "./arrayFileContext.tsx";
import DashboardUtente from "./MainConStatistiche.tsx";

export const adminEmail = "alessiagiannalia28@gmail.com"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AuthProvider> 
    <ConfirmToastProvider>
      <BrowserRouter>
        <FileProvider>
          <Routes>
            <Route 
              path="/signup" 
              element={<LoginPage />} 
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <ProfiloUtente />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <App />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <DashboardUtente />
                </PrivateRoute>
              }
            />
            <Route 
              path="/bye" 
              element={<Goodbye />} 
            />
          </Routes>
        </FileProvider>
      </BrowserRouter>
    </ConfirmToastProvider>
  </AuthProvider>
);
